// ITAM-2677 / ITAM-2734: the favourite-volunteer profile contract (verified
// against apoteka-back branch favourite-delivery-user: VolunteerProfileController,
// VolunteerProfileRequest/Response, VolunteerWorkingHoursRequest/Response).

export type VolunteerDayOfWeek =
  | "MONDAY"
  | "TUESDAY"
  | "WEDNESDAY"
  | "THURSDAY"
  | "FRIDAY"
  | "SATURDAY"
  | "SUNDAY";

export interface VolunteerWorkingHoursEntry {
  dayOfWeek: VolunteerDayOfWeek;
  /** Strictly "HH:mm"; the backend's @JsonFormat rejects "08:00:00" with a 400. */
  availableFrom: string;
  availableUntil: string;
}

export interface VolunteerProfileRequest {
  /** Update lookup; the backend falls back to userId when absent. */
  id?: number;
  /** ALWAYS the logged-in user's own id, never from a route or form field. */
  userId: number;
  /** Update overwrites unconditionally; always send all three text fields. */
  firstName: string;
  secondName: string;
  biography: string;
  /** OMIT to leave the schedule alone; [] clears it. */
  workingHours?: VolunteerWorkingHoursEntry[];
}

export interface VolunteerProfileResponse {
  id: number;
  userId: number;
  firstName: string | null;
  secondName: string | null;
  biography: string | null;
  /** From the account's user_photo; not editable on this page. */
  userPhoto: string | null;
  workingHours: VolunteerWorkingHoursEntry[];
  /** true = on a break, regardless of schedule. */
  paused: boolean;
  /** Computed on read; refetch after saving hours or toggling pause. */
  available: boolean;
}

export const VOLUNTEER_DAYS: VolunteerDayOfWeek[] = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export const VOLUNTEER_DAY_LABELS: Record<VolunteerDayOfWeek, string> = {
  MONDAY: "Ponedeljak",
  TUESDAY: "Utorak",
  WEDNESDAY: "Sreda",
  THURSDAY: "Četvrtak",
  FRIDAY: "Petak",
  SATURDAY: "Subota",
  SUNDAY: "Nedelja",
};
